// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
	--tw-contain-size:  ;
	--tw-contain-layout:  ;
	--tw-contain-paint:  ;
	--tw-contain-style:  ;
}
::backdrop {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
	--tw-contain-size:  ;
	--tw-contain-layout:  ;
	--tw-contain-paint:  ;
	--tw-contain-style:  ;
}
.container {
	width: 100%;
}
@media (min-width: 640px) {
	.container {
		max-width: 640px;
	}
}
@media (min-width: 768px) {
	.container {
		max-width: 768px;
	}
}
@media (min-width: 1024px) {
	.container {
		max-width: 1024px;
	}
}
@media (min-width: 1280px) {
	.container {
		max-width: 1280px;
	}
}
@media (min-width: 1536px) {
	.container {
		max-width: 1536px;
	}
}
.visible {
	visibility: visible;
}
.static {
	position: static;
}
.fixed {
	position: fixed;
}
.absolute {
	position: absolute;
}
.relative {
	position: relative;
}
.sticky {
	position: sticky;
}
.top-0 {
	top: 0px;
}
.top-\\[2px\\] {
	top: 2px;
}
.z-50 {
	z-index: 50;
}
.my-3 {
	margin-top: 0.75rem;
	margin-bottom: 0.75rem;
}
.mb-1 {
	margin-bottom: 0.25rem;
}
.mb-2 {
	margin-bottom: 0.5rem;
}
.mb-3 {
	margin-bottom: 0.75rem;
}
.mb-4 {
	margin-bottom: 1rem;
}
.ml-auto {
	margin-left: auto;
}
.mt-1 {
	margin-top: 0.25rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.mt-4 {
	margin-top: 1rem;
}
.mt-5 {
	margin-top: 1.25rem;
}
.block {
	display: block;
}
.inline {
	display: inline;
}
.flex {
	display: flex;
}
.table {
	display: table;
}
.\\!hidden {
	display: none !important;
}
.hidden {
	display: none;
}
.\\!h-\\[50px\\] {
	height: 50px !important;
}
.\\!h-auto {
	height: auto !important;
}
.h-0 {
	height: 0px;
}
.h-8 {
	height: 2rem;
}
.h-\\[30px\\] {
	height: 30px;
}
.h-\\[5px\\] {
	height: 5px;
}
.w-\\[\\.\\.\\.\\] {
	width: ...;
}
.w-full {
	width: 100%;
}
.w-px {
	width: 1px;
}
.min-w-0 {
	min-width: 0px;
}
.flex-1 {
	flex: 1 1;
}
.shrink-0 {
	flex-shrink: 0;
}
.grow-\\[1\\] {
	flex-grow: 1;
}
.grow-\\[2\\] {
	flex-grow: 2;
}
.grow-\\[N\\] {
	flex-grow: N;
}
.basis-0 {
	flex-basis: 0px;
}
.transform {
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
	resize: both;
}
.flex-row {
	flex-direction: row;
}
.flex-col {
	flex-direction: column;
}
.items-center {
	align-items: center;
}
.justify-between {
	justify-content: space-between;
}
.gap-1 {
	gap: 0.25rem;
}
.gap-2 {
	gap: 0.5rem;
}
.gap-2\\.5 {
	gap: 0.625rem;
}
.gap-3 {
	gap: 0.75rem;
}
.gap-\\[4\\%\\] {
	gap: 4%;
}
.whitespace-nowrap {
	white-space: nowrap;
}
.rounded {
	border-radius: 0.25rem;
}
.rounded-md {
	border-radius: 0.375rem;
}
.rounded-xl {
	border-radius: 0.75rem;
}
.border {
	border-width: 1px;
}
.border-gray-300 {
	--tw-border-opacity: 1;
	border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
	--tw-border-opacity: 1;
	border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#0b7fab\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(11 127 171 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#222\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(34 34 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c8102e\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(200 16 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgb\\(0\\2c 174\\2c 195\\)\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(0 174 195 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgb\\(163_216_231\\)\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(163 216 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgb\\(50_85_155\\)\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(50 85 155 / var(--tw-bg-opacity, 1));
}
.bg-custom-cyan {
	--tw-bg-opacity: 1;
	background-color: rgb(0 174 195 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
	--tw-bg-opacity: 1;
	background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-white {
	--tw-bg-opacity: 1;
	background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.p-2 {
	padding: 0.5rem;
}
.px-2 {
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}
.px-3 {
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.px-3\\.5 {
	padding-left: 0.875rem;
	padding-right: 0.875rem;
}
.px-4 {
	padding-left: 1rem;
	padding-right: 1rem;
}
.py-1 {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}
.py-1\\.5 {
	padding-top: 0.375rem;
	padding-bottom: 0.375rem;
}
.py-2 {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}
.py-3 {
	padding-top: 0.75rem;
	padding-bottom: 0.75rem;
}
.text-left {
	text-align: left;
}
.text-center {
	text-align: center;
}
.text-right {
	text-align: right;
}
.text-\\[0\\.9em\\] {
	font-size: 0.9em;
}
.text-\\[11px\\] {
	font-size: 11px;
}
.text-\\[13px\\] {
	font-size: 13px;
}
.text-sm {
	font-size: 0.875rem;
	line-height: 1.25rem;
}
.font-bold {
	font-weight: 700;
}
.font-medium {
	font-weight: 500;
}
.font-semibold {
	font-weight: 600;
}
.uppercase {
	text-transform: uppercase;
}
.italic {
	font-style: italic;
}
.tracking-\\[1px\\] {
	letter-spacing: 1px;
}
.tracking-wider {
	letter-spacing: 0.05em;
}
.text-\\[red\\] {
	--tw-text-opacity: 1;
	color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[rgb\\(131_131_131\\)\\] {
	--tw-text-opacity: 1;
	color: rgb(131 131 131 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
	--tw-text-opacity: 1;
	color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-red-600 {
	--tw-text-opacity: 1;
	color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
	--tw-text-opacity: 1;
	color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
	text-decoration-line: underline;
}
.no-underline {
	text-decoration-line: none;
}
.outline {
	outline-style: solid;
}
.filter {
	filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.transition-colors {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.duration-200 {
	transition-duration: 200ms;
}

html,
body,
.container_todo {
	height: 100%;
	width: 100%;
	/*min-height:100%;*/
}

body {
  margin: 0; /*50 */
	overflow: hidden;
	display: flex;
  flex-direction: column;
  padding: 0px 5px 5px 5px;
	box-sizing: border-box;
  /*background-color: rgb(236, 225, 243, 0.6) !important;*/
  background-color: white; /*#555466;*/
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container_login {
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  	/*border: 5px solid blue;*/
  	display: flex;
  	flex-direction: column;
  	align-items: space-around;
	height: 100%;
	background-color: rgb(0,174,195);/*rgb(0,174,195)*/ /*restablecer color de fondo*/
	/*overflow: auto;*/
	min-height: 100vh;
}
.container_change_login {
        font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
        display: flex;
        flex-direction: column;
        align-items: space-around;
        height: 80%;
        background-color: white;/*rgb(0,174,195)*/
        min-height: 100vh;
}
.container_form_login {
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  /*border: 5px solid blue;*/
  display: flex;
  flex-direction: column;
  align-items: space-around;
	height: 70%;
	background-color: white;/*rgb(0,174,195)*/
	/*overflow: auto;*/
	min-height: 100vh;
}

.container_login>h1, h2, h3, h4 {
	color: white;
}

.container_form_login>h1, h2, h3, h4 {
	color: white;
}

.container_login button {
	background-color: #838383;
	border-color: #838383;
}

.container_todo {
  /*border: 5px solid blue;*/
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  display: flex;
  flex-direction: column;
  align-items: space-around;
	height: 100%;
	/*overflow: auto;*/
	min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

#my-form{
	width:100%;
	padding: 12px;
}

#customT{
	position: absolute;
	display: none;
  	bottom: 0px;
  	/*left: 5px;*/
  	z-index:1998;
  	width:100%;
  	height:200px;
  	color:black;
	background-color: rgba(0, 45, 68, 0.6) !important;
	overflow-y: scroll;
	overflow-x: scroll;
}

#id_div_input{
        position: absolute;
        display: block;
        top: 0px;
        left: 5px;
        z-index:1998;
        width:300px;
        /*height:100%;*/
        color:black;
        background-color: rgba(0, 45, 68, 0.1) !important;
}

#id_div_respuestaNroGL{
	display:block;
	position:absolute;
	top:10px;
	left:420px;
	width: 400px;
	height: 35px;
	z-index:998;
	background-color: rgba(0, 45, 68, 0.1) !important;
}

#id_div_selectGL{
        display:none;
        position:absolute;
        top:50px;
        left:420px;
        width: 400px;
        height: 35px;
        z-index:998;
        background-color: rgba(0, 45, 68, 0.1) !important;
}

#id_tableId{
	/*overflow-y: scroll;
        overflow-x: scroll;*/

}

#tabla-expediente {
	width: 100%;
}

#tableId tr:hover{
	background-color: #ccc;
}
.a_prueba{
	color:#FFF !important;
}

.col-md-4{
	z-index:1998;
}

/*
.container{
	width: 80%;
}
*/

.flexbox-container {
  //display: -ms-flex;
  //display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-content: space-around;
	/*border: 2px solid green;*/
  z-index:1970;
  //flex-wrap: wrap;
}

/*
.flexbox-container > div {
  //width: 50%;
  padding: 10px;
}
*/

/*
.flexbox-container > div:first-child {
  margin-right: 20px;
}
*/

.header{
	position: sticky;
	/*display: flex;
  flex-direction: row;*/
  top: 0;
  background-color: rgb(0,174,195);
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
	color: white;
	z-index: 500;

	/*height: 120px;*/
	/*border: 4px solid yellow;*/
}

.main {
	/*border: 4px solid black;*/
	/*position: sticky;*/
	/*top: 300px;*/
	max-width: 100%;
	flex: 1 1 auto;
  overflow-y: auto;
  height: 1px; /* con esto se soluciono tema del scroll --> https://dev.to/yas46/sticky-footer-with-flexbox-2128 */
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
	z-index: 700;
	/*color: rgb(131,131,131);*/

  /*overflow: scroll;*/
	/*overflow-y: scroll;*/
}

.footer{
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
	color: white;
	position: sticky;
	background-color: rgb(0,174,195) ;
	/*border: 2px solid yellow;*/
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
	bottom: 0;
	align-items: center;
	justify-content: center;
}
.footer_actuaciones{
	position: relative;
	bottom: 0;
	display: flex;
}
.div_stick {
    position: sticky;
		/*overflow-y: scroll;*/
		z-index: 500;
		top:0px;
		height: 100px;
		width:100%;
		background:white;
		color:rgb(0,174,195);
		/*border-top: 1px solid rgb(0,174,195);*/
}


.container_principal {
  //min-height: 30vh;
  /*border: 5px solid blue;*/ /*CambioD*/
  display: flex;
  flex-direction: column;
  /*background-color: green;*/
  align-items: flex-start;
}

/*//CAMBIO 24-07-22: class container ----> container_inicio*/
.container_inicio { /* Usado dentro de los flexbox-row SOLO en pestaña inicio*/
  //min-height: 100vh;
  //flex-grow: 1;  /* ensures that the container will take up the full height of the parent container */
  /*overflow-y: auto;*/
  /*border: 4px solid yellow;*/ /*cambioA*/
  display: flex;
  flex-direction: column;
  height: 100%;
	width: 33%;
	align-items: center;
	/*border: 6px solid yellow;*/
	color: rgb(131,131,131);
	align-items: strecht;
  /*background-color: cyan;
  align-items: center;*/
}
.container_inicio>select{ /*ADD 24-07-22: para fijar ancho de select in pestaña inicio*/
	width: 80%;
}
.container_inicio>input{
	width: 80%;
}

.align-right{
	align-items: right;
}

.align-right-menu{
	align-items: right;
	margin-left: 2px;
	z-index: 500;
}

.container_tabla { /* Usado dentro de los flexbox-row */
  //min-height: 100vh;
  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */
  display: flex;
  flex-direction: column;
	//justify-content: space-around;
  height: 100%;
	width: 33%;
	margin: 5px;
	align-items: center;
	border: 2px solid red;
	color: rgb(131,131,131);
  /*background-color: cyan;
  align-items: center;*/
}

.container_edit {
  /*border: 5px solid blue;*/
  display: flex;
  flex-direction: column;
  height: 100%;
	width: 98%;
  /*background-color: yellow;*/
  align-items: center;
}

/* PRUEBA */
/*.container_input {
  max-width: 98%;
  display: flex;
  flex-direction: column;
  background-color: black;
  align-items: flex-start;
}*/

/* ***INFORMES ****/
.flex-informe-left{
  height: auto;
  width: 99%;
  margin: 5px;
	/*border: 2px solid green;*/
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}

.flex-informe-center{
  height: auto;
  width: 100%;
  margin: 2px;
	/*border: 2px solid yellow;*/
  display: flex;
  flex-direction: column;
	text-align:justify;
  /*justify-content: space-around;*/
  align-items: center;
}

.flex-informe-right{
  height: auto;
  width: 99%;
  margin: 5px;
	/*border: 2px solid red;*/
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
}
/*** cierra clases para INFORMES ***/

.flexbox-tabla{
  height: auto;
  width: 100%;
  margin: 5px;
  border: 2px solid #333;
  background-color: #dfbfb8;/*grey*/
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
	overflow-x: scroll;
  /*align-items: strecht;*/
  min-height: -webkit-min-content;
}

.container_prueba_loc { /* Usado dentro de los flexbox-row */
	position: relative;
  //min-width: 250px;
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: strecht;
}

.container_prueba_loc>input, .container_prueba_loc>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/
  padding: 0.8em;
  margin: 0.5em;
  width: 99%;
}
.container_prueba_loc>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  color: #ccc;
}
.container_prueba_loc input {
  height: 45px;
  //width: 99%;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 24px 16px 4px 16px;
  font-size: 16px;
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.container_prueba_loc input:focus {
  box-shadow: 0 0 0 2px #79b1ff;
}
/* ----cierra container_prueba_loc --- */


/* prueba 2 - label */
.card_column {
  display: flex;
  height: 45px;
  flex-direction: column;
  width: 33%;
  border: 1px solid #333;
  background-color: yellow;
  //justify-content: space-between;

  //align-items: strecht;
 }

.card_column > .right
{
  background: #ccf;
  flex: 1 1;
}

.dataPicker {
  background-color: blue;
}

button:active{
	background:olive;
}

.buttonInactivo{
	background-color:rgb(163,216,231);
	border-color: rgb(163,216,231);
	color:rgb(131,131,131);
	/*width: 100px;*/
	height: 65px;
	padding: 12px;
	margin-left: 10px;
	/*margin-top: 20px;*/
}

.buttonActivo{
	background-color: rgb(50,85,155);
	border-color: rgb(50,85,155);
	/*width: 100px;*/
	height: 65px;
	padding: 12px;
	margin-left: 10px
}

.buttonVerMapa{
	background-color: rgb(50,85,155);
	border-color: rgb(50,85,155);
	width: 67%;
	height: 70px;
	padding: 12px;
	margin-left: 10px
}

.tableExp{
  color: rgb(131,131,131) ;
}
.tableExp th {
  background-color: rgb(0,174,195);
  color: white;
}
.tableExp tr td {
  color: rgb(131,131,131)
}

#table-madre-to-xls {
	display:none;
}

#table-analitico-to-xls {
	display:none;
}

.subtitulos{
	color: rgb(0,174,195);
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
	font-weight: bold;
}

.subtitulos p {
	align:left;
}

.logo_footer_provincia{
	/*width: 1000px;*/
	align:left;
}

.div_logo_footer{
	flex-direction: row;
	align-items: center;
	/*border-color: yellow;*/
}

.flexbox-row{
  height: auto;
  width: 99%;
  margin: 5px;
  /*border: 1px solid black;*/ /*cambioD*/
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: strecht;
  flex-wrap: wrap;
  /*align-items: strecht;*/
  min-height: -webkit-min-content;
}

.container_row { /* Usado dentro de los flexbox-row */
  /*min-height: 100vh; */
  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */
  display: flex;
  flex-direction: row;
  /*height: 100%;*/
	width: 100%;
	align-items: left;
	/*border: 6px solid green;*/ /*cambioB*/
	color: rgb(131,131,131);
	margin-top: 10px;
  /*background-color: cyan;*/
}

.container_row_hide { /* Usado dentro de los flexbox-row */
  /*min-height: 100vh;*/
  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */
  display: none;
  flex-direction: row;
  /*height: 100%;*/
	width: 100%;
	align-items: left;
	/*border: 4px solid green;*/ /*cambioB*/
	color: rgb(131,131,131);
	margin-top: 10px;
  /*background-color: cyan;*/
}

.container_row_new {  /* USAR SOLO en pruebas*/
  /*min-height: 100vh;*/
  /*flex-grow: 1; */ /* ensures that the container will take up the full height of the parent container */
  display: flex;
  flex-direction: row;
  /*height: 100%;*/
	width: 100%;
	align-items: left;
	border: 4px solid green; /*cambioB*/
	color: rgb(131,131,131);
	margin-top: 10px;
  /*background-color: cyan;*/
}

.container_left { /* Usado dentro de los flexbox-row */
  //min-height: 100vh;
  //flex-grow: 1;  /* ensures that the container will take up the full height of the parent container */
  display: flex;
  flex-direction: row;
  height: 60px;
	width: 100%;
	align-items: left;
	/*border: 6px solid yellow;*/ /*cambioB*/
	color: rgb(131,131,131);
	margin-top: 12px;
	margin-bottom: 12px;
  /*background-color: cyan;*/
}


.container_div_column { /*estilo para div contenedor */
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  /*border: 5px solid red;*/ /*cambioC*/
  display: flex;
  flex-direction: column;
  align-items: stretch;
	/*height: 100%;*/
	/*background-color: cyan;*/
	width: 45%;/* POR AHORA usar al 50%*/
	/*overflow5 auto;*/
	/*min-height: 100vh;*/
	padding-left: 20px;
	padding-right: 20px;
	margin-left: 40px;/*separa margen del margen del padre*/
}

.container_resumen_rp2 { /*estilo para div contenedor */
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  /*border: 5px solid red;*/ /*cambioC*/
  display: flex;
  flex-direction: column;
  align-items: stretch;
	/*height: 100%;*/
	/*background-color: cyan;*/
	width: 45%;/* POR AHORA usar al 50%*/
	/*overflow5 auto;*/
	/*min-height: 100vh;*/
	padding-left: 0px;
	padding-right: 20px;
	margin-left: 0px;/*separa margen del margen del padre*/
}

.span_selectEdit>span {
	color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  /*padding: 10px 10px 0px 0.5em;*/
	padding-left: 20px;
  margin: 0px;
  /*outline: 1px solid red; /*for debugigng purposes only*/
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}


/* ------- para textarea --> input-container -----------------*/
/*.input-container>textarea, .input-container>label{
  //padding: 0.8em;
  //margin: 1px;
  width: 100%;
  //border-radius: 4px;
}*/

.input-container textarea {
  height: 100px;
  /*width: 99%;*/
  border-radius: 4px;
  border: 2px solid #ced4da;
  padding: 24px 16px 4px 16px;
  font-size: 16px;
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.input-container textarea:focus {
  box-shadow: 0 0 0 2px #79b1ff;
}
/* ------- CIERRA textarea --> input-container -----------------*/
.input-number {
  position: relative;
  //min-width: 250px;
  width: 50%;
	height: 60px;
	background: "grey";
  display: flex;
  flex-direction: column;
  /*align-items: strecht;*/
}
.input-number>label{
	position: absolute;
	color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  padding: 0px 0.5em 0px 0.5em;
  margin: 0px;
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}
.input-number>input{
	border: 2px solid #ced4da;
	height: 50px;
	border-radius: 4px;
	padding-left: 4px;
	margin-bottom: 10px;
	color: rgb(131,131,131);
	/*background: gray;*/ /* color de de fondo dentro del input*/
}
/*VER DIFERENCIAS CON ANTERIOR*/
.input-number input {
  height: 50px;
  //width: 99%;
  border-radius: 4px;
  border: 2px solid #ced4da;
  padding: 24px 4px 4px 16px;
  font-size: 16px;
	color: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
	margin-bottom: 10px;
	/*background: cyan;*/
}

/*agregar altura personalizada a datapicker - 12-08-2022 */
.input_data_picker{
	height: 50px;
}


.input-number-45 {
  position: relative;
  //min-width: 250px;
  width: 48%;
  display: flex;
  flex-direction: column;
}
.input-number-45>label{
	position: absolute;
	color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  padding: 0px 0.5em 0px 0.5em;
  margin: 0px;
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}
/*.input-number-45>input{
	border: 2px solid #ced4da;
	height: 50px;
	border-radius: 4px;
	padding-left: 10px;
	margin-bottom: 10px;
}*/
.input-number-45 input {
  height: 45px;
  //width: 99%;
  border-radius: 4px;
  border: 2px solid #ced4da;
  padding: 24px 16px 4px 16px;
  font-size: 16px;
	color: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
	margin-bottom: 10px;
	/*background: green;*/
}

.input-number-45 input:focus {
  box-shadow: 0 0 0 2px #79b1ff;
}
/* +++++++++ Input style   - label y placeholder +++++++++++++*/

.input-container {
  position: relative;
  //min-width: 250px;
	height:"50px";/* 12-08-2022*/
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: strecht;
	/*border: 2px solid blue;*/
}

.input-container>input, .input-container>textarea, .input-container>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/
  //padding: 0.8em;
  //margin: 1px;
  width: 100%; /*ancho del input dentro del div que lo contiene*/
  //border-radius: 4px;
}

.input-container>label{
	position: absolute;
	color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  padding: 0px 0.5em 0px 0.5em;
  margin: 0px;
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}

/*  esta configuracion sirve para todos los inputs */
input:focus + label, input:valid + label{
  color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  padding: 0px 0.5em 0px 0.5em;
  margin: 0px;
  /*outline: 1px solid red; /*for debugigng purposes only*/
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}

.input-container input {
  height: 45px;
  //width: 99%;
  border-radius: 4px;
  border: 2px solid #ced4da;
  padding: 24px 16px 4px 16px;
  font-size: 16px;
	color: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
	margin-bottom: 10px;
	/*background: cyan;*/
}

.input-container input:focus {
  box-shadow: 0 0 0 2px #79b1ff;
}

.input-container textarea {
  height: 120px;
  /*EX 19-09-2026 (reportado por el usuario): min-height igual al alto de diseño para que el
  auto-alto de los textarea (que hace height = scrollHeight en cada tecla) no pueda ACHICAR el
  cuadro. scrollHeight incluye el padding pero no el borde, asi que daba ~116px contra los 120px
  de diseño: esos 4px que se veian como "el cuadro se achica al escribir el primer caracter".
  Con min-height el auto-alto solo puede crecer. Alcanza a los tres tabs, porque todos los
  textarea del formulario viven dentro de .input-container.*/
  min-height: 120px;
  //width: 99%;
  border-radius: 4px;
  border: 2px solid #ced4da;
  padding: 24px 16px 4px 16px;
  font-size: 16px;
	color: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
	margin-bottom: 10px;
	/*background: green;*/
}

.label-fecha{ /*https://codepen.io/Elfangio/pen/zKyzQb*/ /* ESTILO SOLO PARA FECHA DE CARGA?? */
	color: rgb(131,131,131);
  font-size: 0.9em;
  width: auto;
  height: 1.3em;
  padding: 0px 1em 0px 0.5em;
  margin: 0px;
  /*outline: 1px solid red; /*for debugigng purposes only*/
  background: white;
  transition: 0.2s ease-in-out;
  top: -0.8em;
  left: 1em;/* da el desplazamiento del texto al tener enfoque */
}
/* ---- cierra input-container ---- */

/*---div ACTUACIONES ----*/
.container_actuaciones { /*estilo para div contenedor */
	font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;
  border: 1px solid rgb(0,174,195);
	/*border-top: '1 solid yellow';*/
  display: flex;
  flex-direction: column;
  align-items: stretch;
	/*height: 100%;*/
	/*background-color: cyan;*/
	width: 100%;/* POR AHORA usar al 50%*/
	/*overflow: auto;*/
	min-height: 100vh;
	padding-left: 40px;
	padding-right: 40px;
	margin-left: 0px;
}

.hidden_button{
	display:none;
}

#id_button_cancel{
	z-index: 2000;
}

.id_modal_1{
	z-index: 2001;
}
.id_modal_2{
	height: 100%;
	z-index: 2001;
}

/*EX 19-09-2026 (fase 2 - paso 3): esta regla pasa a apuntar por CLASE en vez de por id.
Antes era #id_modal_map, asi que solo alcanzaba a los modales cuyo id coincidia exactamente: el del
ALTA (id="id_modal_map") y el del informe detallado (id="id_modal_map", el que se abre desde "Mapas e
Informes"). El de la EDICION usa id="id_modal_mapE" y NO la recibia nunca. Los tres llevan
className="id_modal_map", y react-bootstrap
pone el id y la className en el MISMO div del dialogo, asi que una sola regla por clase cubre a los
tres. Sin height:100% ni z-index el contenedor del mapa mide mal y Leaflet dibuja con dimensiones
equivocadas: se ven parches transparentes y las capas (el partido) a medio renderizar al hacer zoom
(es la misma causa que ya se documento para el modal del boton "+ NUEVO").
Se borra ademas la regla de #id_modal_map_nuevo / #id_modal_mapE_nuevo: esos ids eran del mapa
candidato del paso 2 y ya no existen en el codigo.
EX 21-09-2026: la pantalla que antes llamabamos "Monitor" (/monitor, components/monitor/monitor.js) se
elimino en f9b8d87 porque nunca tuvo entrada de menu. El modal del informe detallado NO se toca: vive en
monitor/select_inf_detallado.js y lo monta monitor/informe_2_detallado.js, que sigue usandose desde
mapas.js (menu "Mapas e Informes"). Por eso los tres modales siguen siendo tres.*/
.id_modal_map{
	height: 100%;
	z-index: 2001;
}

.button_true{
	background: "white";
}

.button_false{
	background: "black";
}

.button_rojo{
	background-color: rgb(190,23,23);
	color: white;
	margin-left: 10px;
	border: none;
}

.button_verde{
	background-color: rgb(0,167,84);
	color: white;
	margin-left: 10px;
	border: none;
}

.text_button{
	color: white;
}

.text_button:hover{
	color: rgb(92, 99, 106);
}

#pr2{
	/*resize: none;*/
  /*overflow-y: hidden;*/
	/*height:auto;*/
}

.leaflet-div-icon {
  background-color: #f4f4f4;
  border: 1px solid #666;
  border-radius: 50%;
  display: inline-block;
}

.leaflet-editing-icon {
  background-color: #f4f4f4;
  border: 1px solid #666;
  border-radius: 50%;
  width: 12px !important;
  height: 12px !important;
  display: inline-block;
}

.info{
  /*background-color: #fff;*/
  /*padding: 10px;
  border-radius: 5px;*/
  /*border: 5px solid blue;*/
  z-index:2000;
  pointer-events: none;
}

.refreshButton {
  position: absolute;
  top: 130px;
  left: 0px;
  z-index:2000;
  width:50px;
  height:50px;
  color:white;
  border-radius: 5px;
  border-color: #00AEC3;
  background-color: #00AEC3; /*rgba(0,0,0,0.8)*/
  /*pointer-events: auto;*/
}

.refreshButtonInactivo {
  position: absolute;
  top: 130px;
  left: 0px;
  z-index:1000;
  width:50px;
  height:50px;
  color: white;
  border-radius: 5px;
  background-color: rgba(0,45,68,0.6);
}

.selectButton {
  display: block;
  position: absolute;
  top:1px;
  right:50px;
  width: 240px !important;
  z-index:2001;
  /*background-color:rgba(238,238,238,0.4);*/
  background-color:rgba(0,45,68,0.6);
  padding:4px;
  /*border:1px solid gray;*/
  font-size:12px;
  max-height: 45%;
  overflow: auto;
}

/*.legend {
  position: absolute;
  padding: 6px 8px;
  font: 14px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 0.8);
  z-index:2000;  
  line-height: 24px;
  color: #555;
}*/

.legend {
  position: absolute;
  z-index: 999;
  left: 10px;
  bottom: 10px;
  padding:6px 8px;
  box-shadow: 0 0 5px 0 rgba(184, 140, 140, 0.3);
  font-size:12px;
  letter-spacing:2px;
  background: white;/*rgba(0,0,0,0.8);*/
  border-radius:5px;
  width: 25%;
}
.legend > div {
  color: rgb(131,131,131);/*white;*/
  position: relative;
  display: flex;
  height: 20px;
  padding: 0 10px;
}
.legend > div::before {
  content: "";
  background-color: var(--color);
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  
}

.floatingCapas{
	display:block;
  /*color:white;*/
	position:absolute;
  top:0px;
  right:0px;
  width: 321px;
  height: 100%;
  z-index:3000;
  border: 1px solid #00AEC3;

  background-color: rgb(255, 255, 255) !important;

  /*background: rgba(0,0,0,0.8);*/
  
  /*background-color: var(--color);*/
	/*box-shadow: 3px 3px rgba(0,0,0 ,0.6);*/
	box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
  overflow-y: auto;
  /*pointer-events: none;*/
}

.spanNav {
  padding-left: 10px;
}

.input-wrapper{
  position: relative;
  display: flex;
  margin-bottom: 14px;
}
.input-wrapper-right{
  position: relative;
  display: flex;
  margin-bottom: 14px;
  text-align: end;
}

.input-icon {
	color: #00AEC3;
	position: absolute;
	width: 20px;
	height: 20px;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
}

.input-icon.password {
	left: unset;
	right: 12px;
}

.purple{
  font-size: 80px;
  color: blue
}

.spinner {
  
  color: white;
  animation: spin infinite 1.2s linear;
  font-size: 30px;
  top: 50%;
  transform: translateY(-50%);
  /*padding-left: 10px;*/
  /*animation: circle 1.2s steps(8) infinite;*/

  /*You can increase or decrease the timer (5s) to 
   increase or decrease the speed of the spinner
   https://stackoverflow.com/questions/64508793/fontawesome-spinner-wont-spin-in-react*/
}

@keyframes spin {
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
}

.hover\\:bg-\\[\\#333\\]:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:text-red-800:hover {
	--tw-text-opacity: 1;
	color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {
	.sm\\:inline {
		display: inline;
	}
	.sm\\:gap-4 {
		gap: 1rem;
	}
	.sm\\:gap-5 {
		gap: 1.25rem;
	}
}

@media (min-width: 1024px) {
	.lg\\:inline {
		display: inline;
	}
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd,sBAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,qBAAc;CAAd;AAAc;AAAd;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd,sBAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,qBAAc;CAAd;AAAc;AACd;CAAA;AAAoB;AAApB;CAAA;EAAA;CAAoB;AAAA;AAApB;CAAA;EAAA;CAAoB;AAAA;AAApB;CAAA;EAAA;CAAoB;AAAA;AAApB;CAAA;EAAA;CAAoB;AAAA;AAApB;CAAA;EAAA;CAAoB;AAAA;AACpB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,wJAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,+FAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;;AAEnB;;;CAGC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;EACE,SAAS,EAAE,MAAM;CAClB,gBAAgB;CAChB,aAAa;EACZ,sBAAsB;EACtB,wBAAwB;CACzB,sBAAsB;EACrB,wDAAwD;EACxD,uBAAuB,EAAE,WAAW;EACpC;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;CACC,qFAAqF;GACnF,0BAA0B;GAC1B,aAAa;GACb,sBAAsB;GACtB,yBAAyB;CAC3B,YAAY;CACZ,gCAAgC,CAAC,iBAAiB,EAAE,6BAA6B;CACjF,kBAAkB;CAClB,iBAAiB;AAClB;AACA;QACQ,qFAAqF;QACrF,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,WAAW;QACX,uBAAuB,CAAC,iBAAiB;QACzC,iBAAiB;AACzB;AACA;CACC,qFAAqF;EACpF,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;CAC1B,WAAW;CACX,uBAAuB,CAAC,iBAAiB;CACzC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;EACE,0BAA0B;CAC3B,qFAAqF;EACpF,aAAa;EACb,sBAAsB;EACtB,yBAAyB;CAC1B,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;CACC,UAAU;CACV,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,aAAa;GACX,WAAW;GACX,aAAa;GACb,YAAY;GACZ,UAAU;GACV,YAAY;GACZ,WAAW;CACb,iDAAiD;CACjD,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;QACQ,kBAAkB;QAClB,cAAc;QACd,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,WAAW;QACX,eAAe;QACf,WAAW;QACX,iDAAiD;AACzD;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,iDAAiD;AAClD;;AAEA;QACQ,YAAY;QACZ,iBAAiB;QACjB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,iDAAiD;AACzD;;AAEA;CACC;4BAC2B;;AAE5B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;;;;CAIC;;AAED;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;CAC5B,2BAA2B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;CACC,gBAAgB;CAChB;uBACsB;EACrB,MAAM;EACN,gCAAgC;CACjC,qFAAqF;CACrF,YAAY;CACZ,YAAY;;CAEZ,iBAAiB;CACjB,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;CAC3B,oBAAoB;CACpB,cAAc;CACd,eAAe;CACf,cAAc;EACb,gBAAgB;EAChB,WAAW,EAAE,mGAAmG;CACjH,qFAAqF;CACrF,YAAY;CACZ,2BAA2B;;EAE1B,oBAAoB;CACrB,sBAAsB;AACvB;;AAEA;CACC,qFAAqF;CACrF,YAAY;CACZ,gBAAgB;CAChB,iCAAiC;CACjC,4BAA4B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;CACf,SAAS;CACT,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,aAAa;AACd;AACA;IACI,gBAAgB;EAClB,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,0BAA0B,EAAE,UAAU;EACtC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D,oBAAoB,0DAA0D;EAC5E,mBAAmB;EACnB,cAAc,GAAG,oFAAoF;EACrG,oBAAoB;EACpB,4BAA4B,EAAE,UAAU;EACxC,aAAa;EACb,sBAAsB;EACtB,YAAY;CACb,UAAU;CACV,mBAAmB;CACnB,4BAA4B;CAC5B,uBAAuB;CACvB,oBAAoB;EACnB;uBACqB;AACvB;AACA,0BAA0B,6DAA6D;CACtF,UAAU;AACX;AACA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;AACb;;AAEA,mBAAmB,oCAAoC;EACrD,mBAAmB;EACnB,gBAAgB,GAAG,oFAAoF;EACvG,aAAa;EACb,sBAAsB;CACvB,+BAA+B;EAC9B,YAAY;CACb,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,qBAAqB;CACrB,uBAAuB;EACtB;uBACqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,YAAY;CACb,UAAU;EACT,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,WAAW;AACX;;;;;;EAME;;AAEF,mBAAmB;AACnB;EACE,YAAY;EACZ,UAAU;EACV,WAAW;CACZ,2BAA2B;EAC1B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;CACZ,4BAA4B;EAC3B,aAAa;EACb,sBAAsB;CACvB,kBAAkB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;CACZ,yBAAyB;EACxB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,oCAAoC;;AAEpC;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,yBAAyB,CAAC,OAAO;EACjC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;CAChB,kBAAkB;EACjB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,wBAAwB,oCAAoC;CAC3D,kBAAkB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,0DAA0D,yCAAyC;EACjG,cAAc;EACd,aAAa;EACb,UAAU;AACZ;AACA,6BAA6B,yCAAyC;EACpE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;AACA,wCAAwC;;;AAGxC,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;;EAEhC,sBAAsB;CACvB;;AAED;;EAEE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,sBAAsB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;CACjC,8BAA8B;CAC9B,sBAAsB;CACtB,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb;AACD;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,UAAU;CACV,YAAY;CACZ,aAAa;CACb;AACD;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,YAAY;AACd;AACA;EACE;AACF;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,qFAAqF;CACrF,iBAAiB;AAClB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,2BAA2B,EAAE,UAAU;EACvC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,iBAAiB,oCAAoC;EACnD,sBAAsB;EACtB,gBAAgB,GAAG,oFAAoF;EACvG,aAAa;EACb,mBAAmB;EACnB,gBAAgB;CACjB,WAAW;CACX,iBAAiB;CACjB,2BAA2B,EAAE,UAAU;CACvC,uBAAuB;CACvB,gBAAgB;EACf,0BAA0B;AAC5B;;AAEA,sBAAsB,oCAAoC;EACxD,qBAAqB;EACrB,gBAAgB,GAAG,oFAAoF;EACvG,aAAa;EACb,mBAAmB;EACnB,gBAAgB;CACjB,WAAW;CACX,iBAAiB;CACjB,2BAA2B,EAAE,UAAU;CACvC,uBAAuB;CACvB,gBAAgB;EACf,0BAA0B;AAC5B;;AAEA,sBAAsB,wBAAwB;EAC5C,qBAAqB;EACrB,iBAAiB,EAAE,oFAAoF;EACvG,aAAa;EACb,mBAAmB;EACnB,gBAAgB;CACjB,WAAW;CACX,iBAAiB;CACjB,uBAAuB,EAAE,UAAU;CACnC,uBAAuB;CACvB,gBAAgB;EACf,0BAA0B;AAC5B;;AAEA,kBAAkB,oCAAoC;EACpD,mBAAmB;EACnB,cAAc,GAAG,oFAAoF;EACrG,aAAa;EACb,mBAAmB;EACnB,YAAY;CACb,WAAW;CACX,iBAAiB;CACjB,4BAA4B,EAAE,UAAU;CACxC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;EAClB,0BAA0B;AAC5B;;;AAGA,wBAAwB,8BAA8B;CACrD,qFAAqF;EACpF,yBAAyB,EAAE,UAAU;EACrC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;CACrB,gBAAgB;CAChB,0BAA0B;CAC1B,UAAU,CAAC,yBAAyB;CACpC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB,CAAC,qCAAqC;AACxD;;AAEA,yBAAyB,8BAA8B;CACtD,qFAAqF;EACpF,yBAAyB,EAAE,UAAU;EACrC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;CACrB,gBAAgB;CAChB,0BAA0B;CAC1B,UAAU,CAAC,yBAAyB;CACpC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB,CAAC,qCAAqC;AACvD;;AAEA;CACC,uBAAuB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gCAAgC;CACjC,kBAAkB;EACjB,WAAW;EACX,wDAAwD;EACxD,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;;;AAGA,+DAA+D;AAC/D;;;;;EAKE;;AAEF;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;AACA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX,YAAY;CACZ,kBAAkB;EACjB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;CACC,kBAAkB;CAClB,uBAAuB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,oBAAoB,EAAE,sCAAsC;AAC7D;AACA,+BAA+B;AAC/B;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;CAChB,uBAAuB,EAAE,yDAAyD;EACjF,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;CACjD,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA,0DAA0D;AAC1D;CACC,YAAY;AACb;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;CACC,kBAAkB;CAClB,uBAAuB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;AACA;;;;;;EAME;AACF;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;CAChB,uBAAuB,EAAE,yDAAyD;EACjF,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;CACjD,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,kBAAkB;CACnB,aAAa,CAAC,cAAc;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;CACrB,0BAA0B;AAC3B;;AAEA,2EAA2E,yCAAyC;EAClH,gBAAgB;EAChB,aAAa;EACb,WAAW,EAAE,iDAAiD;EAC9D,oBAAoB;AACtB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,wDAAwD;EACxD,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;CAChB,uBAAuB,EAAE,yDAAyD;EACjF,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;CACjD,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb;;;;;4DAK0D;EAC1D,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;CAChB,uBAAuB,EAAE,yDAAyD;EACjF,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gDAAgD;CACjD,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA,cAAc,yCAAyC,EAAE,sCAAsC;CAC9F,uBAAuB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,wDAAwD;EACxD,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS,CAAC,oDAAoD;AAChE;AACA,qCAAqC;;AAErC,0BAA0B;AAC1B,yBAAyB,8BAA8B;CACtD,qFAAqF;EACpF,gCAAgC;CACjC,gCAAgC;EAC/B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;CACrB,gBAAgB;CAChB,0BAA0B;CAC1B,WAAW,CAAC,yBAAyB;CACrC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;AACA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;;;;;;;;;;;;;;iFAciF;AACjF;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;EACf,sBAAsB;CACvB,eAAe;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB,EAAE,kBAAkB;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;;EASE;;AAEF;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,iBAAiB,CAAC,mBAAmB;EACrC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,uBAAuB,CAAC,SAAS;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;CACC,aAAa;EACZ,eAAe;CAChB,iBAAiB;EAChB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;;EAEzB,+CAA+C;;EAE/C,+BAA+B;;EAE/B,kCAAkC;CACnC,wCAAwC;CACxC,iHAAiH;EAChH,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,4CAA4C;;EAE5C;;uFAEqF;AACvF;;AAEA;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;;AAhoCA;CAAA,kBAioCA;CAjoCA;AAioCA;;AAjoCA;CAAA,kBAioCA;CAjoCA;AAioCA;;AAjoCA;CAAA,oBAioCA;CAjoCA;AAioCA;;AAjoCA;CAAA;EAAA;CAioCA;CAjoCA;EAAA;CAioCA;CAjoCA;EAAA;CAioCA;AAAA;;AAjoCA;CAAA;EAAA;CAioCA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml,\nbody,\n.container_todo {\n\theight: 100%;\n\twidth: 100%;\n\t/*min-height:100%;*/\n}\n\nbody {\n  margin: 0; /*50 */\n\toverflow: hidden;\n\tdisplay: flex;\n  flex-direction: column;\n  padding: 0px 5px 5px 5px;\n\tbox-sizing: border-box;\n  /*background-color: rgb(236, 225, 243, 0.6) !important;*/\n  background-color: white; /*#555466;*/\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.container_login {\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  \t/*border: 5px solid blue;*/\n  \tdisplay: flex;\n  \tflex-direction: column;\n  \talign-items: space-around;\n\theight: 100%;\n\tbackground-color: rgb(0,174,195);/*rgb(0,174,195)*/ /*restablecer color de fondo*/\n\t/*overflow: auto;*/\n\tmin-height: 100vh;\n}\n.container_change_login {\n        font-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n        display: flex;\n        flex-direction: column;\n        align-items: space-around;\n        height: 80%;\n        background-color: white;/*rgb(0,174,195)*/\n        min-height: 100vh;\n}\n.container_form_login {\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  /*border: 5px solid blue;*/\n  display: flex;\n  flex-direction: column;\n  align-items: space-around;\n\theight: 70%;\n\tbackground-color: white;/*rgb(0,174,195)*/\n\t/*overflow: auto;*/\n\tmin-height: 100vh;\n}\n\n.container_login>h1, h2, h3, h4 {\n\tcolor: white;\n}\n\n.container_form_login>h1, h2, h3, h4 {\n\tcolor: white;\n}\n\n.container_login button {\n\tbackground-color: #838383;\n\tborder-color: #838383;\n}\n\n.container_todo {\n  /*border: 5px solid blue;*/\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  display: flex;\n  flex-direction: column;\n  align-items: space-around;\n\theight: 100%;\n\t/*overflow: auto;*/\n\tmin-height: 100vh;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n#my-form{\n\twidth:100%;\n\tpadding: 12px;\n}\n\n#customT{\n\tposition: absolute;\n\tdisplay: none;\n  \tbottom: 0px;\n  \t/*left: 5px;*/\n  \tz-index:1998;\n  \twidth:100%;\n  \theight:200px;\n  \tcolor:black;\n\tbackground-color: rgba(0, 45, 68, 0.6) !important;\n\toverflow-y: scroll;\n\toverflow-x: scroll;\n}\n\n#id_div_input{\n        position: absolute;\n        display: block;\n        top: 0px;\n        left: 5px;\n        z-index:1998;\n        width:300px;\n        /*height:100%;*/\n        color:black;\n        background-color: rgba(0, 45, 68, 0.1) !important;\n}\n\n#id_div_respuestaNroGL{\n\tdisplay:block;\n\tposition:absolute;\n\ttop:10px;\n\tleft:420px;\n\twidth: 400px;\n\theight: 35px;\n\tz-index:998;\n\tbackground-color: rgba(0, 45, 68, 0.1) !important;\n}\n\n#id_div_selectGL{\n        display:none;\n        position:absolute;\n        top:50px;\n        left:420px;\n        width: 400px;\n        height: 35px;\n        z-index:998;\n        background-color: rgba(0, 45, 68, 0.1) !important;\n}\n\n#id_tableId{\n\t/*overflow-y: scroll;\n        overflow-x: scroll;*/\n\n}\n\n#tabla-expediente {\n\twidth: 100%;\n}\n\n#tableId tr:hover{\n\tbackground-color: #ccc;\n}\n.a_prueba{\n\tcolor:#FFF !important;\n}\n\n.col-md-4{\n\tz-index:1998;\n}\n\n/*\n.container{\n\twidth: 80%;\n}\n*/\n\n.flexbox-container {\n  //display: -ms-flex;\n  //display: -webkit-flex;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  align-content: space-around;\n\t/*border: 2px solid green;*/\n  z-index:1970;\n  //flex-wrap: wrap;\n}\n\n/*\n.flexbox-container > div {\n  //width: 50%;\n  padding: 10px;\n}\n*/\n\n/*\n.flexbox-container > div:first-child {\n  margin-right: 20px;\n}\n*/\n\n.header{\n\tposition: sticky;\n\t/*display: flex;\n  flex-direction: row;*/\n  top: 0;\n  background-color: rgb(0,174,195);\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n\tcolor: white;\n\tz-index: 500;\n\n\t/*height: 120px;*/\n\t/*border: 4px solid yellow;*/\n}\n\n.main {\n\t/*border: 4px solid black;*/\n\t/*position: sticky;*/\n\t/*top: 300px;*/\n\tmax-width: 100%;\n\tflex: 1 1 auto;\n  overflow-y: auto;\n  height: 1px; /* con esto se soluciono tema del scroll --> https://dev.to/yas46/sticky-footer-with-flexbox-2128 */\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n\tz-index: 700;\n\t/*color: rgb(131,131,131);*/\n\n  /*overflow: scroll;*/\n\t/*overflow-y: scroll;*/\n}\n\n.footer{\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n\tcolor: white;\n\tposition: sticky;\n\tbackground-color: rgb(0,174,195) ;\n\t/*border: 2px solid yellow;*/\n  display: flex;\n  flex-direction: row;\n  flex: 0 0 auto;\n\tbottom: 0;\n\talign-items: center;\n\tjustify-content: center;\n}\n.footer_actuaciones{\n\tposition: relative;\n\tbottom: 0;\n\tdisplay: flex;\n}\n.div_stick {\n    position: sticky;\n\t\t/*overflow-y: scroll;*/\n\t\tz-index: 500;\n\t\ttop:0px;\n\t\theight: 100px;\n\t\twidth:100%;\n\t\tbackground:white;\n\t\tcolor:rgb(0,174,195);\n\t\t/*border-top: 1px solid rgb(0,174,195);*/\n}\n\n\n.container_principal {\n  //min-height: 30vh;\n  /*border: 5px solid blue;*/ /*CambioD*/\n  display: flex;\n  flex-direction: column;\n  /*background-color: green;*/\n  align-items: flex-start;\n}\n\n/*//CAMBIO 24-07-22: class container ----> container_inicio*/\n.container_inicio { /* Usado dentro de los flexbox-row SOLO en pestaña inicio*/\n  //min-height: 100vh;\n  //flex-grow: 1;  /* ensures that the container will take up the full height of the parent container */\n  /*overflow-y: auto;*/\n  /*border: 4px solid yellow;*/ /*cambioA*/\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\twidth: 33%;\n\talign-items: center;\n\t/*border: 6px solid yellow;*/\n\tcolor: rgb(131,131,131);\n\talign-items: strecht;\n  /*background-color: cyan;\n  align-items: center;*/\n}\n.container_inicio>select{ /*ADD 24-07-22: para fijar ancho de select in pestaña inicio*/\n\twidth: 80%;\n}\n.container_inicio>input{\n\twidth: 80%;\n}\n\n.align-right{\n\talign-items: right;\n}\n\n.align-right-menu{\n\talign-items: right;\n\tmargin-left: 2px;\n\tz-index: 500;\n}\n\n.container_tabla { /* Usado dentro de los flexbox-row */\n  //min-height: 100vh;\n  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */\n  display: flex;\n  flex-direction: column;\n\t//justify-content: space-around;\n  height: 100%;\n\twidth: 33%;\n\tmargin: 5px;\n\talign-items: center;\n\tborder: 2px solid red;\n\tcolor: rgb(131,131,131);\n  /*background-color: cyan;\n  align-items: center;*/\n}\n\n.container_edit {\n  /*border: 5px solid blue;*/\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\twidth: 98%;\n  /*background-color: yellow;*/\n  align-items: center;\n}\n\n/* PRUEBA */\n/*.container_input {\n  max-width: 98%;\n  display: flex;\n  flex-direction: column;\n  background-color: black;\n  align-items: flex-start;\n}*/\n\n/* ***INFORMES ****/\n.flex-informe-left{\n  height: auto;\n  width: 99%;\n  margin: 5px;\n\t/*border: 2px solid green;*/\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: flex-start;\n}\n\n.flex-informe-center{\n  height: auto;\n  width: 100%;\n  margin: 2px;\n\t/*border: 2px solid yellow;*/\n  display: flex;\n  flex-direction: column;\n\ttext-align:justify;\n  /*justify-content: space-around;*/\n  align-items: center;\n}\n\n.flex-informe-right{\n  height: auto;\n  width: 99%;\n  margin: 5px;\n\t/*border: 2px solid red;*/\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: flex-end;\n}\n/*** cierra clases para INFORMES ***/\n\n.flexbox-tabla{\n  height: auto;\n  width: 100%;\n  margin: 5px;\n  border: 2px solid #333;\n  background-color: #dfbfb8;/*grey*/\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: flex-start;\n  flex-wrap: wrap;\n\toverflow-x: scroll;\n  /*align-items: strecht;*/\n  min-height: -webkit-min-content;\n}\n\n.container_prueba_loc { /* Usado dentro de los flexbox-row */\n\tposition: relative;\n  //min-width: 250px;\n  width: 33%;\n  display: flex;\n  flex-direction: column;\n  align-items: strecht;\n}\n\n.container_prueba_loc>input, .container_prueba_loc>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/\n  padding: 0.8em;\n  margin: 0.5em;\n  width: 99%;\n}\n.container_prueba_loc>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  color: #ccc;\n}\n.container_prueba_loc input {\n  height: 45px;\n  //width: 99%;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  padding: 24px 16px 4px 16px;\n  font-size: 16px;\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.container_prueba_loc input:focus {\n  box-shadow: 0 0 0 2px #79b1ff;\n}\n/* ----cierra container_prueba_loc --- */\n\n\n/* prueba 2 - label */\n.card_column {\n  display: flex;\n  height: 45px;\n  flex-direction: column;\n  width: 33%;\n  border: 1px solid #333;\n  background-color: yellow;\n  //justify-content: space-between;\n\n  //align-items: strecht;\n }\n\n.card_column > .right\n{\n  background: #ccf;\n  flex: 1;\n}\n\n.dataPicker {\n  background-color: blue;\n}\n\nbutton:active{\n\tbackground:olive;\n}\n\n.buttonInactivo{\n\tbackground-color:rgb(163,216,231);\n\tborder-color: rgb(163,216,231);\n\tcolor:rgb(131,131,131);\n\t/*width: 100px;*/\n\theight: 65px;\n\tpadding: 12px;\n\tmargin-left: 10px;\n\t/*margin-top: 20px;*/\n}\n\n.buttonActivo{\n\tbackground-color: rgb(50,85,155);\n\tborder-color: rgb(50,85,155);\n\t/*width: 100px;*/\n\theight: 65px;\n\tpadding: 12px;\n\tmargin-left: 10px\n}\n\n.buttonVerMapa{\n\tbackground-color: rgb(50,85,155);\n\tborder-color: rgb(50,85,155);\n\twidth: 67%;\n\theight: 70px;\n\tpadding: 12px;\n\tmargin-left: 10px\n}\n\n.tableExp{\n  color: rgb(131,131,131) ;\n}\n.tableExp th {\n  background-color: rgb(0,174,195);\n  color: white;\n}\n.tableExp tr td {\n  color: rgb(131,131,131)\n}\n\n#table-madre-to-xls {\n\tdisplay:none;\n}\n\n#table-analitico-to-xls {\n\tdisplay:none;\n}\n\n.subtitulos{\n\tcolor: rgb(0,174,195);\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n\tfont-weight: bold;\n}\n\n.subtitulos p {\n\talign:left;\n}\n\n.logo_footer_provincia{\n\t/*width: 1000px;*/\n\talign:left;\n}\n\n.div_logo_footer{\n\tflex-direction: row;\n\talign-items: center;\n\t/*border-color: yellow;*/\n}\n\n.flexbox-row{\n  height: auto;\n  width: 99%;\n  margin: 5px;\n  /*border: 1px solid black;*/ /*cambioD*/\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: strecht;\n  flex-wrap: wrap;\n  /*align-items: strecht;*/\n  min-height: -webkit-min-content;\n}\n\n.container_row { /* Usado dentro de los flexbox-row */\n  /*min-height: 100vh; */\n  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */\n  display: flex;\n  flex-direction: row;\n  /*height: 100%;*/\n\twidth: 100%;\n\talign-items: left;\n\t/*border: 6px solid green;*/ /*cambioB*/\n\tcolor: rgb(131,131,131);\n\tmargin-top: 10px;\n  /*background-color: cyan;*/\n}\n\n.container_row_hide { /* Usado dentro de los flexbox-row */\n  /*min-height: 100vh;*/\n  /*flex-grow: 1;*/  /* ensures that the container will take up the full height of the parent container */\n  display: none;\n  flex-direction: row;\n  /*height: 100%;*/\n\twidth: 100%;\n\talign-items: left;\n\t/*border: 4px solid green;*/ /*cambioB*/\n\tcolor: rgb(131,131,131);\n\tmargin-top: 10px;\n  /*background-color: cyan;*/\n}\n\n.container_row_new {  /* USAR SOLO en pruebas*/\n  /*min-height: 100vh;*/\n  /*flex-grow: 1; */ /* ensures that the container will take up the full height of the parent container */\n  display: flex;\n  flex-direction: row;\n  /*height: 100%;*/\n\twidth: 100%;\n\talign-items: left;\n\tborder: 4px solid green; /*cambioB*/\n\tcolor: rgb(131,131,131);\n\tmargin-top: 10px;\n  /*background-color: cyan;*/\n}\n\n.container_left { /* Usado dentro de los flexbox-row */\n  //min-height: 100vh;\n  //flex-grow: 1;  /* ensures that the container will take up the full height of the parent container */\n  display: flex;\n  flex-direction: row;\n  height: 60px;\n\twidth: 100%;\n\talign-items: left;\n\t/*border: 6px solid yellow;*/ /*cambioB*/\n\tcolor: rgb(131,131,131);\n\tmargin-top: 12px;\n\tmargin-bottom: 12px;\n  /*background-color: cyan;*/\n}\n\n\n.container_div_column { /*estilo para div contenedor */\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  /*border: 5px solid red;*/ /*cambioC*/\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\t/*height: 100%;*/\n\t/*background-color: cyan;*/\n\twidth: 45%;/* POR AHORA usar al 50%*/\n\t/*overflow5 auto;*/\n\t/*min-height: 100vh;*/\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\tmargin-left: 40px;/*separa margen del margen del padre*/\n}\n\n.container_resumen_rp2 { /*estilo para div contenedor */\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  /*border: 5px solid red;*/ /*cambioC*/\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\t/*height: 100%;*/\n\t/*background-color: cyan;*/\n\twidth: 45%;/* POR AHORA usar al 50%*/\n\t/*overflow5 auto;*/\n\t/*min-height: 100vh;*/\n\tpadding-left: 0px;\n\tpadding-right: 20px;\n\tmargin-left: 0px;/*separa margen del margen del padre*/\n}\n\n.span_selectEdit>span {\n\tcolor: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  /*padding: 10px 10px 0px 0.5em;*/\n\tpadding-left: 20px;\n  margin: 0px;\n  /*outline: 1px solid red; /*for debugigng purposes only*/\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n\n\n/* ------- para textarea --> input-container -----------------*/\n/*.input-container>textarea, .input-container>label{\n  //padding: 0.8em;\n  //margin: 1px;\n  width: 100%;\n  //border-radius: 4px;\n}*/\n\n.input-container textarea {\n  height: 100px;\n  /*width: 99%;*/\n  border-radius: 4px;\n  border: 2px solid #ced4da;\n  padding: 24px 16px 4px 16px;\n  font-size: 16px;\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.input-container textarea:focus {\n  box-shadow: 0 0 0 2px #79b1ff;\n}\n/* ------- CIERRA textarea --> input-container -----------------*/\n.input-number {\n  position: relative;\n  //min-width: 250px;\n  width: 50%;\n\theight: 60px;\n\tbackground: \"grey\";\n  display: flex;\n  flex-direction: column;\n  /*align-items: strecht;*/\n}\n.input-number>label{\n\tposition: absolute;\n\tcolor: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  padding: 0px 0.5em 0px 0.5em;\n  margin: 0px;\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n.input-number>input{\n\tborder: 2px solid #ced4da;\n\theight: 50px;\n\tborder-radius: 4px;\n\tpadding-left: 4px;\n\tmargin-bottom: 10px;\n\tcolor: rgb(131,131,131);\n\t/*background: gray;*/ /* color de de fondo dentro del input*/\n}\n/*VER DIFERENCIAS CON ANTERIOR*/\n.input-number input {\n  height: 50px;\n  //width: 99%;\n  border-radius: 4px;\n  border: 2px solid #ced4da;\n  padding: 24px 4px 4px 16px;\n  font-size: 16px;\n\tcolor: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n\tmargin-bottom: 10px;\n\t/*background: cyan;*/\n}\n\n/*agregar altura personalizada a datapicker - 12-08-2022 */\n.input_data_picker{\n\theight: 50px;\n}\n\n\n.input-number-45 {\n  position: relative;\n  //min-width: 250px;\n  width: 48%;\n  display: flex;\n  flex-direction: column;\n}\n.input-number-45>label{\n\tposition: absolute;\n\tcolor: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  padding: 0px 0.5em 0px 0.5em;\n  margin: 0px;\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n/*.input-number-45>input{\n\tborder: 2px solid #ced4da;\n\theight: 50px;\n\tborder-radius: 4px;\n\tpadding-left: 10px;\n\tmargin-bottom: 10px;\n}*/\n.input-number-45 input {\n  height: 45px;\n  //width: 99%;\n  border-radius: 4px;\n  border: 2px solid #ced4da;\n  padding: 24px 16px 4px 16px;\n  font-size: 16px;\n\tcolor: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n\tmargin-bottom: 10px;\n\t/*background: green;*/\n}\n\n.input-number-45 input:focus {\n  box-shadow: 0 0 0 2px #79b1ff;\n}\n/* +++++++++ Input style   - label y placeholder +++++++++++++*/\n\n.input-container {\n  position: relative;\n  //min-width: 250px;\n\theight:\"50px\";/* 12-08-2022*/\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: strecht;\n\t/*border: 2px solid blue;*/\n}\n\n.input-container>input, .input-container>textarea, .input-container>label{ /*https://codepen.io/Elfangio/pen/zKyzQb*/\n  //padding: 0.8em;\n  //margin: 1px;\n  width: 100%; /*ancho del input dentro del div que lo contiene*/\n  //border-radius: 4px;\n}\n\n.input-container>label{\n\tposition: absolute;\n\tcolor: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  padding: 0px 0.5em 0px 0.5em;\n  margin: 0px;\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n\n/*  esta configuracion sirve para todos los inputs */\ninput:focus + label, input:valid + label{\n  color: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  padding: 0px 0.5em 0px 0.5em;\n  margin: 0px;\n  /*outline: 1px solid red; /*for debugigng purposes only*/\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n\n.input-container input {\n  height: 45px;\n  //width: 99%;\n  border-radius: 4px;\n  border: 2px solid #ced4da;\n  padding: 24px 16px 4px 16px;\n  font-size: 16px;\n\tcolor: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n\tmargin-bottom: 10px;\n\t/*background: cyan;*/\n}\n\n.input-container input:focus {\n  box-shadow: 0 0 0 2px #79b1ff;\n}\n\n.input-container textarea {\n  height: 120px;\n  /*EX 19-09-2026 (reportado por el usuario): min-height igual al alto de diseño para que el\n  auto-alto de los textarea (que hace height = scrollHeight en cada tecla) no pueda ACHICAR el\n  cuadro. scrollHeight incluye el padding pero no el borde, asi que daba ~116px contra los 120px\n  de diseño: esos 4px que se veian como \"el cuadro se achica al escribir el primer caracter\".\n  Con min-height el auto-alto solo puede crecer. Alcanza a los tres tabs, porque todos los\n  textarea del formulario viven dentro de .input-container.*/\n  min-height: 120px;\n  //width: 99%;\n  border-radius: 4px;\n  border: 2px solid #ced4da;\n  padding: 24px 16px 4px 16px;\n  font-size: 16px;\n\tcolor: rgb(131,131,131); /* <================CAMBIAR color texto segùn normativa */\n  line-height: 1;\n  outline: none;\n  box-shadow: none;\n  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n\tmargin-bottom: 10px;\n\t/*background: green;*/\n}\n\n.label-fecha{ /*https://codepen.io/Elfangio/pen/zKyzQb*/ /* ESTILO SOLO PARA FECHA DE CARGA?? */\n\tcolor: rgb(131,131,131);\n  font-size: 0.9em;\n  width: auto;\n  height: 1.3em;\n  padding: 0px 1em 0px 0.5em;\n  margin: 0px;\n  /*outline: 1px solid red; /*for debugigng purposes only*/\n  background: white;\n  transition: 0.2s ease-in-out;\n  top: -0.8em;\n  left: 1em;/* da el desplazamiento del texto al tener enfoque */\n}\n/* ---- cierra input-container ---- */\n\n/*---div ACTUACIONES ----*/\n.container_actuaciones { /*estilo para div contenedor */\n\tfont-family: Arial, source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace;\n  border: 1px solid rgb(0,174,195);\n\t/*border-top: '1 solid yellow';*/\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\t/*height: 100%;*/\n\t/*background-color: cyan;*/\n\twidth: 100%;/* POR AHORA usar al 50%*/\n\t/*overflow: auto;*/\n\tmin-height: 100vh;\n\tpadding-left: 40px;\n\tpadding-right: 40px;\n\tmargin-left: 0px;\n}\n\n.hidden_button{\n\tdisplay:none;\n}\n\n#id_button_cancel{\n\tz-index: 2000;\n}\n\n.id_modal_1{\n\tz-index: 2001;\n}\n.id_modal_2{\n\theight: 100%;\n\tz-index: 2001;\n}\n\n/*EX 19-09-2026 (fase 2 - paso 3): esta regla pasa a apuntar por CLASE en vez de por id.\nAntes era #id_modal_map, asi que solo alcanzaba a los modales cuyo id coincidia exactamente: el del\nALTA (id=\"id_modal_map\") y el del informe detallado (id=\"id_modal_map\", el que se abre desde \"Mapas e\nInformes\"). El de la EDICION usa id=\"id_modal_mapE\" y NO la recibia nunca. Los tres llevan\nclassName=\"id_modal_map\", y react-bootstrap\npone el id y la className en el MISMO div del dialogo, asi que una sola regla por clase cubre a los\ntres. Sin height:100% ni z-index el contenedor del mapa mide mal y Leaflet dibuja con dimensiones\nequivocadas: se ven parches transparentes y las capas (el partido) a medio renderizar al hacer zoom\n(es la misma causa que ya se documento para el modal del boton \"+ NUEVO\").\nSe borra ademas la regla de #id_modal_map_nuevo / #id_modal_mapE_nuevo: esos ids eran del mapa\ncandidato del paso 2 y ya no existen en el codigo.\nEX 21-09-2026: la pantalla que antes llamabamos \"Monitor\" (/monitor, components/monitor/monitor.js) se\nelimino en f9b8d87 porque nunca tuvo entrada de menu. El modal del informe detallado NO se toca: vive en\nmonitor/select_inf_detallado.js y lo monta monitor/informe_2_detallado.js, que sigue usandose desde\nmapas.js (menu \"Mapas e Informes\"). Por eso los tres modales siguen siendo tres.*/\n.id_modal_map{\n\theight: 100%;\n\tz-index: 2001;\n}\n\n.button_true{\n\tbackground: \"white\";\n}\n\n.button_false{\n\tbackground: \"black\";\n}\n\n.button_rojo{\n\tbackground-color: rgb(190,23,23);\n\tcolor: white;\n\tmargin-left: 10px;\n\tborder: none;\n}\n\n.button_verde{\n\tbackground-color: rgb(0,167,84);\n\tcolor: white;\n\tmargin-left: 10px;\n\tborder: none;\n}\n\n.text_button{\n\tcolor: white;\n}\n\n.text_button:hover{\n\tcolor: rgb(92, 99, 106);\n}\n\n#pr2{\n\t/*resize: none;*/\n  /*overflow-y: hidden;*/\n\t/*height:auto;*/\n}\n\n.leaflet-div-icon {\n  background-color: #f4f4f4;\n  border: 1px solid #666;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.leaflet-editing-icon {\n  background-color: #f4f4f4;\n  border: 1px solid #666;\n  border-radius: 50%;\n  width: 12px !important;\n  height: 12px !important;\n  display: inline-block;\n}\n\n.info{\n  /*background-color: #fff;*/\n  /*padding: 10px;\n  border-radius: 5px;*/\n  /*border: 5px solid blue;*/\n  z-index:2000;\n  pointer-events: none;\n}\n\n.refreshButton {\n  position: absolute;\n  top: 130px;\n  left: 0px;\n  z-index:2000;\n  width:50px;\n  height:50px;\n  color:white;\n  border-radius: 5px;\n  border-color: #00AEC3;\n  background-color: #00AEC3; /*rgba(0,0,0,0.8)*/\n  /*pointer-events: auto;*/\n}\n\n.refreshButtonInactivo {\n  position: absolute;\n  top: 130px;\n  left: 0px;\n  z-index:1000;\n  width:50px;\n  height:50px;\n  color: white;\n  border-radius: 5px;\n  background-color: rgba(0,45,68,0.6);\n}\n\n.selectButton {\n  display: block;\n  position: absolute;\n  top:1px;\n  right:50px;\n  width: 240px !important;\n  z-index:2001;\n  /*background-color:rgba(238,238,238,0.4);*/\n  background-color:rgba(0,45,68,0.6);\n  padding:4px;\n  /*border:1px solid gray;*/\n  font-size:12px;\n  max-height: 45%;\n  overflow: auto;\n}\n\n/*.legend {\n  position: absolute;\n  padding: 6px 8px;\n  font: 14px Arial, Helvetica, sans-serif;\n  background: white;\n  background: rgba(255, 255, 255, 0.8);\n  z-index:2000;  \n  line-height: 24px;\n  color: #555;\n}*/\n\n.legend {\n  position: absolute;\n  z-index: 999;\n  left: 10px;\n  bottom: 10px;\n  padding:6px 8px;\n  box-shadow: 0 0 5px 0 rgba(184, 140, 140, 0.3);\n  font-size:12px;\n  letter-spacing:2px;\n  background: white;/*rgba(0,0,0,0.8);*/\n  border-radius:5px;\n  width: 25%;\n}\n.legend > div {\n  color: rgb(131,131,131);/*white;*/\n  position: relative;\n  display: flex;\n  height: 20px;\n  padding: 0 10px;\n}\n.legend > div::before {\n  content: \"\";\n  background-color: var(--color);\n  left: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  \n}\n\n.floatingCapas{\n\tdisplay:block;\n  /*color:white;*/\n\tposition:absolute;\n  top:0px;\n  right:0px;\n  width: 321px;\n  height: 100%;\n  z-index:3000;\n  border: 1px solid #00AEC3;\n\n  background-color: rgb(255, 255, 255) !important;\n\n  /*background: rgba(0,0,0,0.8);*/\n  \n  /*background-color: var(--color);*/\n\t/*box-shadow: 3px 3px rgba(0,0,0 ,0.6);*/\n\tbox-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;\n  overflow-y: auto;\n  /*pointer-events: none;*/\n}\n\n.spanNav {\n  padding-left: 10px;\n}\n\n.input-wrapper{\n  position: relative;\n  display: flex;\n  margin-bottom: 14px;\n}\n.input-wrapper-right{\n  position: relative;\n  display: flex;\n  margin-bottom: 14px;\n  text-align: end;\n}\n\n.input-icon {\n\tcolor: #00AEC3;\n\tposition: absolute;\n\twidth: 20px;\n\theight: 20px;\n\tleft: 12px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n.input-icon.password {\n\tleft: unset;\n\tright: 12px;\n}\n\n.purple{\n  font-size: 80px;\n  color: blue\n}\n\n.spinner {\n  \n  color: white;\n  animation: spin infinite 1.2s linear;\n  font-size: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  /*padding-left: 10px;*/\n  /*animation: circle 1.2s steps(8) infinite;*/\n\n  /*You can increase or decrease the timer (5s) to \n   increase or decrease the speed of the spinner\n   https://stackoverflow.com/questions/64508793/fontawesome-spinner-wont-spin-in-react*/\n}\n\n@keyframes spin {\nfrom {\n  transform: rotate(0deg);\n}\nto {\n  transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
